import * as React from "react";
import { Toolbar, Typography, Paper } from "@material-ui/core";
import styled from "styled-components";
import LogoBox from "./LogoBox";
import Theme from "../Theme";
import TabMenu from "./TabMenu";
import AccountMenuIcon from "./AccountMenuIcon";
import { Link } from "react-router-dom";

const LogoBar = styled(Toolbar)`
  z-index: 1;
  background-color: ${Theme.colors.darkBackground};
  height: ${Theme.sizes.navHeight};
  padding: 0;
  color: ${Theme.colors.white};
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;

  position: fixed;
  top: 0;
  left: 0;
`;

const TitleRow = styled.div`
  width: 100%;
  height: 66px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${Theme.colors.white};
`;

const MenuRow = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const Title = styled(Typography)`
  font-family: ${Theme.fonts.title};
  font-size: ${Theme.sizes.title};
  font-weight: 100;
  letter-spacing: 0.02em;
  line-height: 1.2em;
  text-align: center;
  flex: 1 1 auto;
  width: 40%;

  &&& a {
    transition: color 0.2s ease-in;
    color: ${Theme.colors.white};
    text-decoration: none;
  }

  &&& a:hover {
    color: ${Theme.colors.accentWarmLight};
  }
`;

const AccountMenuContainer = styled.div`
  height: 66px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  width: 30%;
`;

const LogoDiv = styled.div`
  width: 30%;
`;

export interface INavMenuProps {}

export default class NavMenu extends React.PureComponent<INavMenuProps, {}> {
  public render() {
    return (
      <LogoBar>
        <TitleRow>
          <LogoDiv>
            <LogoBox />
          </LogoDiv>
          <Title variant="h6">
            <Link to="/">
              <strong>Partner</strong> Portal
            </Link>
          </Title>
          <AccountMenuContainer>
            <AccountMenuIcon />
          </AccountMenuContainer>
        </TitleRow>
        <MenuRow>
          <TabMenu />
        </MenuRow>
      </LogoBar>
    );
  }
}
